var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('ul',[_c('li',{staticClass:"d-flex",style:({'color': _vm.textColor, 'font-weight': _vm.isBoldText ? 'bold' : 'normal'})},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content.dsc_texto)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }